import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { cn } from "../../utils/styles";
import { useCampaignOpeningAssistHighlightId } from "../../pages/NewAdsCampaign/context/CampaignOpeningAssistContext";

const OpeningAssistHighlight = ({
  messageKey,
  hasOptimizationCards = false,
  children,
}) => {
  const highlightMessageId = useCampaignOpeningAssistHighlightId();
  const prefersReducedMotion = useMediaQuery(
    "(prefers-reduced-motion: reduce)"
  );

  const isHighlighted =
    highlightMessageId != null &&
    highlightMessageId === messageKey &&
    !prefersReducedMotion;

  if (!isHighlighted) {
    return children;
  }

  const className = hasOptimizationCards
    ? cn("openingAssistHeartbeatHost openingAssistHeartbeatCardOnce")
    : cn("openingAssistHeartbeatHost openingAssistHeartbeatOnce");

  return <Box className={className}>{children}</Box>;
};

export default OpeningAssistHighlight;
